var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Route } from "react-router";
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Loader, Message } from 'semantic-ui-react';
import { RnaCatalogType } from "../../admin/EditOrderKit";
import { AppPaths, UiConfigContext } from "../../AppConfig";
import rnaLogo from '../../images/logo_RNA.png';
import { CatalogMode } from "../../RequestHelpers";
import CornerLogoContainer from "../CornerLogoContainer";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import { RelevantCatalogType } from "../automated-pro/RnaCatalog";
import { RnaCatalogLoader } from "../automated-pro/RnaCatalogLoader";
import { CART_PRICE_PATH } from "../rna-fish/EditKitForm";
import { LoadWrapper } from "../rna-fish/LoadWrapper";
import { addToCartHandlerBuilder } from "../rna-fish/NewRnaFishKitPage";
import EditKitForm, { defaultFormState } from "./ManualProConsumerKitForm";
var NewManualProConsumerKitPage = /** @class */ (function (_super) {
    __extends(NewManualProConsumerKitPage, _super);
    function NewManualProConsumerKitPage(props) {
        return _super.call(this, props) || this;
    }
    NewManualProConsumerKitPage.prototype.render = function () {
        var _this = this;
        var renderer = function (catalog) {
            return React.createElement(NewKitContent, { catalog: catalog, adminUser: _this.props.adminUser });
        };
        return React.createElement(LoadWrapper, { loader: new RnaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial, RnaCatalogType.RnaFish), render: renderer });
    };
    return NewManualProConsumerKitPage;
}(React.PureComponent));
export default NewManualProConsumerKitPage;
var NewKitContent = /** @class */ (function (_super) {
    __extends(NewKitContent, _super);
    function NewKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true,
                addToCartButtonPressed: true
            }, callback);
        }, function () { return JSON.stringify(EditKitForm.serializeManualProConsumerKit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        // Helper to allow us to access Route info in a click handler
        _this.addToCartButton = function (props) {
            var onClick = function () {
                // tslint tells me that inline lambdas in props are slow, so we do it here...?
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { icon: 'cart plus', label: 'Add to cart', labelPosition: 'left', onClick: onClick, positive: true });
        };
        _this.state = {
            loading: false,
            formState: defaultFormState(props.catalog),
            addToCartButtonPressed: false
        };
        return _this;
    }
    NewKitContent.prototype.render = function () {
        return React.createElement(CornerLogoContainer, { img: rnaLogo, alt: 'RNA logo' },
            React.createElement("div", { id: "non-header-portion" },
                React.createElement("h1", { className: 'branded' }, "HCR™ Pro RNA-ISH Kit"),
                React.createElement("h2", { className: 'branded', style: { width: '87%' } }, "Extreme-sensitivity RNA imaging with chromogenic or fluorescent staining"),
                React.createElement("span", { style: { float: 'right', marginTop: '2rem' } }, React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-pro-protocols" }, "HCR\u2122 Pro User Guide")),
                React.createElement("p", { className: 'branded', style: { width: '50%' } },
                    "Use with an HRP chromogen for RNA-CISH or an HRP fluorogenic substrate for RNA-FISH. HCR\u2122 Pro is currently available as a 1-plex assay. For higher-plex experiments, use ",
                    React.createElement("a", { href: AppPaths.LOCAL_NEW_KIT_RNA_FISH }, "HCR\u2122 Gold RNA-FISH"),
                    ", which supports up to 10-plex. Learn more in our HCR\u2122 Pro RNA-ISH ",
                    React.createElement("a", { href: "https://molecularinstruments.com/faq#pro-rnaish-faq" }, "FAQ"),
                    "."),
                React.createElement("br", null),
                React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
                    if (!uiConfig.authenticated) {
                        return React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                            React.createElement("h2", { className: 'branded' }, "Special Pricing for Academic Users!"),
                            React.createElement(Link, { to: AppPaths.REGISTER }, "Register"),
                            " to see applicable discounts. Special academic pricing is applied to your account automatically once you\u2019re signed in.",
                            React.createElement("br", null),
                            " ",
                            React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                            " ",
                            React.createElement("br", null));
                    }
                    else {
                        return React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                            React.createElement("h2", { className: 'branded' }, "HCR\u2122 Pro RNA-ISH Kits for Manual Workflows Launched in June 2025!"),
                            "Alternatively, HCR\u2122 Pro RNA-ISH kits for BOND RX/RX",
                            React.createElement("sup", null, "m"),
                            ", DISCOVERY ULTRA, or ONCORE Pro X autostaining platforms are available ",
                            React.createElement("a", { href: 'https://store.hcrimaging.com' + AppPaths.LOCAL_NEW_KIT_RNA_CISH, target: '_blank', rel: 'noopener noreferrer' }, "here"),
                            ".",
                            React.createElement("br", null),
                            " ",
                            React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                            " ",
                            React.createElement("br", null));
                    }
                }),
                React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.formState.errors.length > 0 },
                    React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                        React.createElement(Loader, null)),
                    this.state.formState &&
                        React.createElement(React.Fragment, null,
                            React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, formState: this.state.formState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableNegativeControlProbe: true, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, setFormState: this.setFormState, showErrors: this.state.addToCartButtonPressed }),
                            React.createElement("div", null,
                                React.createElement("div", { style: { float: 'right' } },
                                    React.createElement("div", { style: { 'textAlign': 'right' } },
                                        React.createElement(Route, { render: this.addToCartButton }))),
                                React.createElement("div", { style: { clear: 'both' } }))))));
    };
    return NewKitContent;
}(React.PureComponent));
//# sourceMappingURL=NewManualProConsumerKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/NewManualProConsumerKitPage.js
// module id = 1375
// module chunks = 0